const initState = {
  sessionExpired: false,
  isLoading: false,
  currentAdmin: {
    email: "",
    role: "",
    token: "",
  },
  currentSection: "home",
};

const statusReducer = (state = initState, action) => {
  if (action.type === "UPDATE_IS_LOADING") {
    return {
      ...state,
      isLoading: action.payload,
    };
  } else if (action.type === "UPDATE_CURRENT_ADMIN") {
    return {
      ...state,
      currentAdmin: action.payload,
    };
  } else if (action.type === "UPDATE_SESSION_EXPIRED") {
    return {
      ...state,
      sessionExpired: action.payload,
    };
  } else if (action.type === "UPDATE_CURRENT_SECTION") {
    return {
      ...state,
      currentSection: action.payload,
    };
  }

  return state;
};

export default statusReducer;
